import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getIsLoading = (state) => get(state, 'auth.isLoading', false);
export const getToken = (state) => get(state, 'auth.token', null);
export const getIsAuthenticated = (state) => get(state, 'auth.isAuthenticated', false);
export const getUser = (state) => get(state, 'auth.user', null);
export const getCompany = (state) => get(state, 'auth.company', null);
export const getSubcompany = (state) => get(state, 'auth.subcompany', null);

export const getUserCompaniesIds = (state) => get(state, 'auth.result.companies', []);
export const getUserCompanies = (state) => get(state, 'auth.entities.userCompanies', {});
export const getRoles = (state) => get(state, 'auth.entities.roles', {});

export const getVisibleRoles = createSelector(
  [getUserCompaniesIds, getUserCompanies, getRoles],
  (ids, userCompanies, roles) => ids.map((id) => roles[userCompanies[id].role])
);

export const getCurrentRole = createSelector(
  [getCompany, getVisibleRoles],
  (company, roles) => company && roles.find((r) => r._company === company.id)
);

export const getPermissions = createSelector(
  [getCurrentRole],
  (role) => role && role.permissions.reduce((re, p) => ({ ...re, [p]: true }), {})
);

export const makeGetRoleByCompany = () =>
  createSelector([getVisibleRoles, (_, { companyId }) => companyId], (roles, companyId) =>
    roles.find((role) => role._company === companyId)
  );



// WEBPACK FOOTER //
// src/modules/auth/selectors/auth_selectors.js